import script from "./autoRunning.vue?vue&type=script&setup=true&lang=js"
export * from "./autoRunning.vue?vue&type=script&setup=true&lang=js"

import "./autoRunning.vue?vue&type=style&index=0&id=018588f4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-018588f4"]])

export default __exports__